const initialState = {
  levels: [],
  targets: [],
  stages: [],
  stageContent: [],
  headers: [],
  combinations: [],
  scoreComparisons: [],
  plans: [],
  subscriptionFeatures: [],
  levelTargetContent: [],
  stageDetails: {},
  roadmapOverview: {},
  isLoading: true,
  error: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case "FETCH_ROADMAP_DATA":
      return {
        ...state,
        levels: action.payload.levels || [],
        targets: action.payload.targets || [],
        stages: action.payload.stages || [],
        stageContent: action.payload.stageContent || [],
        headers: action.payload.headers || [],
        combinations: action.payload.combinations || [],
        scoreComparisons: action.payload.scoreComparisons || [],
        plans: action.payload.plans || [],
        levelTargetContent: action.payload.levelTargetContent || [],
        isLoading: false,
      };

    case "ROADMAP_LOADING":
      return {
        ...state,
        isLoading: true,
      };

    case "ROADMAP_ERROR":
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case "ADD_SUBSCRIPTION_FEATURE_SUCCESS":
      return {
        ...state,
        subscriptionFeatures: [...state.subscriptionFeatures, action.payload],
      };

    case "UPDATE_SUBSCRIPTION_FEATURE_SUCCESS":
      return {
        ...state,
        subscriptionFeatures: state.subscriptionFeatures.map((feature) =>
          feature.id === action.payload.id ? action.payload : feature
        ),
      };

    case "FETCH_STAGE_DETAILS_SUCCESS":
      return {
        ...state,
        stageDetails: action.payload,
        isLoading: false,
      };

    case "FETCH_ROADMAP_OVERVIEW_SUCCESS":
      return {
        ...state,
        roadmapOverview: action.payload,
        isLoading: false,
      };

    default:
      return state;
  }
}
